export const CREATE_STORES = 'Create a set of stores to view throughout the reporting suite.';
export const BUNDLE_ITEMS = 'Bundle items into categories.';
export const STILL_PROCESSING = 'Still processing data. Almost there!';
export const HANG_TIGHT = "Hang tight! We're processing large amounts of data!";
export const UNABLE_CLICK_TO = 'Unable to complete the request. Click to ';
export const ERROR_CREATING_GROUP = 'An error occurred trying to create the group.';
export const ERROR_UPDATING_GROUP = 'An error occurred trying to update the group.';
export const PROCESSING_EXPORTS =
  "We're processing your exports. You will receive an email in a few minutes.";
export const ERROR_PROCESSING_EXPORTS = 'Error processing your exports. Please, try again.';
export const PRINT_CURRENT_PAGE =
  'This is an export of only the data that is being displayed on the current page.';
export const RAW_WEEKLY_EXPORT_DATA =
  'A CSV file of raw weekly store level data that you can analyze.';

export const CURRENT_PAGE_EXPORT = 'currentPage';
export const RAW_WEEKLY_TITTLE = 'Raw Weekly Store Data';
export const RAW_WEEKLY_EXPORT = 'rawWeekly';
export const RAW_WEEKLY_TEMPLATE = 'storeSalesTrendSeries';
export const CONFIRM_YOUR_EMAIL =
  'Please confirm your email address below and the files will be sent to you shortly.';
